import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { TbGalaxy } from "react-icons/tb";

const HelpCenter = () => {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [activeStep, setActiveStep] = useState(0);
    const [activeStepConnector, setActiveStepConnector] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const [privacyChecked, setPrivacyChecked] = useState(false);

    const emailRef = useRef(null);
    const messageRef = useRef(null);

    const steps = ['first_bubbly_step', 'second_bubbly_step', 'third_bubbly_step'];
    const connectors = ['first_bubbly_connector', 'second_bubbly_connector', 'third_bubbly_connector'];

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveStep((prevStep) => (prevStep + 1) % steps.length);
        }, 2000);

        const intervalConnector = setInterval(() => {
            setActiveStepConnector((prevStep) => (prevStep + 1) % connectors.length);
        }, 2000);

        return () => {
            clearInterval(interval);
            clearInterval(intervalConnector);
        };
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                startRegister();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-]{10,20}$/;

    const validateEmail = (email) => {
        return emailRegex.test(email);
    };

    const validatePassword = (password) => {
        return passwordRegex.test(password);
    };

    function startRegister() {
        setErr({ message: "", display: false })
        const email_reg = emailRef.current;
        const message_reg = messageRef.current;

        let error = false;
        let error_email = false;


        if (!email_reg.value) {
            error = true;
            email_reg.style.border = "1px solid var(--danger)";
        } else if (!validateEmail(email_reg.value)) {
            error = true;
            error_email = true;
            email_reg.style.border = "1px solid var(--danger)";
        } else {
            email_reg.style.border = "";
        }

        if (!message_reg.value) {
            error = true;
            message_reg.style.border = "1px solid var(--danger)";
        }  else {
            message_reg.style.border = "";
        }

        const privacy_policy_desc = document.getElementById("privacy_policy_desc");
        if (!privacyChecked) {
            error = true;
            privacy_policy_desc.style.color = "var(--danger)";
        } else {
            privacy_policy_desc.style.color = "";
        }

        if (error) {
            if (error_email) {
                setErr({ message: t.register_form.email_format, display: true });
            } else {
                setErr({ message: t.register_form.red_fields, display: true });
            }
        } else {
            SaveData(email_reg.value, message_reg.value)
        }
    }

    function SaveData(email, message) {
        setLoading(true);
        let dataToSave = {
            email: email,
            message: message,
        };

        fetch('https://backend.erioon.com/help_center', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSave),
        })
            .then(response => response.json())
            .then(data => {
                console.log(data)
                setLoading(false);
                if (data.message === "OK") {
                    setErr({ message: "", display: false });
                    navigate(`/successful-help-request`);
                } else if (data.message === "Invalid_email_address") {
                    setErr({ message: t.register_form.email_format, display: true });
                } else if (data.message === "All_fields_required") {
                    setErr({ message: t.register_form.red_fields, display: true });
                } else if (data.error) {
                    console.log(data);
                    setErr({ message: t.register_form.errors_back, display: true });
                }
            })
            .catch(error => {
                setLoading(false);
                console.error(error);
                setErr({ message: t.register_form.problem_back, display: true });
            });
    }


    return (
        <div className="prereg_main">
            <div className="main_navbar">
                <div className="navbar">
                    <div className="nav_cont_1">
                        <a href="/">
                            <p id="title_navbar">
                                <i><TbGalaxy /></i>
                                Erioon
                            </p>
                        </a>
                    </div>
                    <div className="nav_cont_1">

                    </div>
                </div>
            </div>
            <div className="help_center_cont_inner">
                <div className="register_conts_reg">
                    <div className="reg_cont">
                        <p className="call_action_title">Help center</p>
                        <p className="call_action_subtitle">Leave a message and we'll get back to you in 24h.</p>

                        <input ref={emailRef} type="text" id="email_reg" placeholder="Email" className="register_form_first"></input>
                        <textarea ref={messageRef} type="text" id="message_reg" placeholder="Message" className="register_form_first textarea_reg"></textarea>

                        <div className="second_cont_reg">
                            <div className="priv_mail_cont">
                                <input type="checkbox" checked={privacyChecked} onChange={() => setPrivacyChecked(!privacyChecked)} />
                                <p id="privacy_policy_desc">{t.register_form.privacy_policy_desc} <Link to={"/privacy-policy"}>{t.register_form.p_p}</Link></p>
                            </div>
                        </div>
                        <button onClick={startRegister} className="start_btn">
                            {loading ? (
                                <Spinner loading={loading} />
                            ) : (
                                <>
                                    Send message <i className="fa-solid fa-paper-plane"></i>
                                </>
                            )
                            }
                        </button>
                        <ErrorMessage err={err} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HelpCenter